import type React from 'react';
import { useTheme } from 'styled-components';

import Typography from '../../Typography/index.ts';
import { FileState } from './FileState.tsx';
import { Filebox } from './styled.ts';
import type { SingleFileProps } from './types.ts';

const File: React.FC<SingleFileProps> = ({ error, fileName, isUploading, success = false, progress, handleReset, tryAnotherText }) => {
  const theme = useTheme();

  return (
    <>
      <Filebox $error={!!error}>
        <Typography.TextMedium>{fileName}</Typography.TextMedium>
        <FileState
          error={error}
          isUploading={isUploading}
          onReset={handleReset}
          progress={progress}
          success={success}
          tryAnotherText={tryAnotherText}
        />
      </Filebox>
      {error && <Typography.TextMedium color={theme.colors.critical100}>{error}</Typography.TextMedium>}
    </>
  );
};

export default File;
